// Footer
import React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const Footer = () => {

  return (
    <Box 
      component="footer"
      sx={{
        height: 38,
        minHeight: 38,
        color: '#868E96',
        py: 2,
        px: 3,
        mt: 'auto',
        backgroundColor: '#FDFBFE',
        borderTop: '1px solid rgba(0, 0, 0, 0.10)',
      }}
    >
      <Toolbar sx={{ minHeight: 'auto !important' }}>
        <Stack
            direction="row"
            width="100%"
            justifyContent="flex-end"
            alignItems="center"
          >
          <Typography variant="body2" sx={{ fontSize: '12px' }}>
            © 2025 Heart Kium. All rights reserved.
          </Typography>
        </Stack>
      </Toolbar>
    </Box>
  );
};
